import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { editProfileBunja } from '../../../bunja';

export const Intro = () => {
  const t = useTranslations();
  const { introductionAtom, isMasterTraderAtom, introductionLengthAtom, maxIntroductionLength } =
    useBunja(editProfileBunja);
  const isMasterTrader = useAtomValue(isMasterTraderAtom);
  const [intro, setIntro] = useAtom(introductionAtom);
  const introductionLength = useAtomValue(introductionLengthAtom);
  if (!isMasterTrader) return null;
  return (
    <div className={stack({ gap: 12 })}>
      <label htmlFor='intro' className={css({ textStyle: 'Text/L/Strong', color: 'content.default.level-5' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Intro' />
      </label>
      <div
        className={stack({
          backgroundColor: 'background.default.level-1',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'border.default.level-3',
          transition: 'border-color 200ms',
          rounded: 4,
          p: 12,
          _focusWithin: {
            '&:not(:disabled)': {
              borderColor: 'content.default.level-2',
              '& > button': {
                display: 'inherit',
              },
            },
          },
          _hover: {
            '&:not(:disabled)': {
              borderColor: 'content.default.level-2',
              '& > button': {
                display: 'inherit',
              },
            },
          },
        })}
      >
        <textarea
          value={intro}
          placeholder={t('Autogen_common.r251126.s_Give_an_intro_of_yourself')}
          onChange={(e) => setIntro(e.currentTarget.value)}
          className={css({
            resize: 'none',
            width: '100%',
            backgroundColor: 'transparent',
            border: 'none',
            caretColor: 'blue.500',
            textStyle: 'Text/L/Regular',
            color: 'content.default.level-5',
            scrollbarWidth: 'thin',
            minH: 66,
          })}
        />
        <p
          className={css(
            { color: 'content.default.level-2', alignSelf: 'flex-end' },
            introductionLength > maxIntroductionLength && { color: 'content.state.negative' },
          )}
        >
          {introductionLength} / {maxIntroductionLength}
        </p>
      </div>
    </div>
  );
};
